import { Specialty } from './specialty.entity';

export class Doctor {
  id: string;
  name: string;
  medicalCenter: string;
  specialty: Specialty;
  availableDays: Date[];

  constructor({
    id,
    name,
    medicalCenter,
    specialty,
    availableDays
  }: {
    id: string;
    name: string;
    medicalCenter: string;
    specialty: Specialty;
    availableDays: Date[];
  }) {
    this.id = id;
    this.name = name;
    this.medicalCenter = medicalCenter;
    this.specialty = specialty;
    this.availableDays = availableDays;
  }
}
